module.exports = __webpack_public_path__ + "public/SiteIcons/envelope.png?95104e58";